import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { NomPiece } from 'app/models/nomPiece.model';

@Injectable({
  providedIn: 'root'
})
export class NomPieceService {

  private API_URL = environment.API_URL;
  private MODEL_URL = 'noms-pieces';

  constructor(private http: HttpClient) { }

  getNomsPieces(): Observable<NomPiece[]> {
    return this.http.get<NomPiece[]>(this.API_URL + this.MODEL_URL);
  }

  store(nomPiece: NomPiece): Observable<NomPiece>{
    return this.http.post<NomPiece>(this.API_URL + this.MODEL_URL, nomPiece).pipe(
      catchError(err => throwError(err))
    );
  }
}
